import type {
  DocumentTypeDomain,
  DocumentTypeRecurrenceAnchor,
} from '@shared/dto/document-type/document-type-catalog.constants';

export interface DeadlineDefaultsSource {
  domain: DocumentTypeDomain | null;
  defaultValidityMonths: number | null;
  defaultWarningDays: number[];
  recurrenceAnchor: DocumentTypeRecurrenceAnchor | null;
  warningOnly: boolean;
  isPersonal: boolean;
}

export interface DeadlineFormDefaults {
  domain: DocumentTypeDomain | null;
  warningDays: number[];
  validityMonths: number | null;
  askValidity: boolean;
  recurrenceAnchor: DocumentTypeRecurrenceAnchor | null;
  isPersonal: boolean;
}

const FALLBACK_WARNING_DAYS = [7];

/** Specchio lato UI delle regole di `resolveCatalogDefaults` (backend): il server resta la verità. */
export function getDeadlineFormDefaults(
  documentType: DeadlineDefaultsSource | null | undefined,
): DeadlineFormDefaults {
  if (!documentType) {
    return {
      domain: null,
      warningDays: [...FALLBACK_WARNING_DAYS],
      validityMonths: null,
      askValidity: true,
      recurrenceAnchor: null,
      isPersonal: false,
    };
  }
  const askValidity = documentType.defaultValidityMonths === null || documentType.warningOnly;
  return {
    domain: documentType.domain,
    warningDays:
      documentType.defaultWarningDays.length > 0
        ? [...documentType.defaultWarningDays]
        : [...FALLBACK_WARNING_DAYS],
    validityMonths: documentType.warningOnly ? null : documentType.defaultValidityMonths,
    askValidity,
    recurrenceAnchor: documentType.recurrenceAnchor,
    isPersonal: documentType.isPersonal,
  };
}
